"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var SHORT_TEXT_POSTFIX = '...';

var CollapsableText =
/*#__PURE__*/
function (_React$Component) {
  _inherits(CollapsableText, _React$Component);

  function CollapsableText(props) {
    var _this;

    _classCallCheck(this, CollapsableText);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CollapsableText).call(this, props));
    var showButton = props.text.length > props.shortTextMaxLength;
    _this.state = {
      showToggleButton: showButton,
      collapsed: showButton && props.collapsed,
      shortText: props.text.substring(0, props.shortTextMaxLength) + SHORT_TEXT_POSTFIX
    };
    _this.toggleCollapse = _this.toggleCollapse.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(CollapsableText, [{
    key: "toggleCollapse",
    value: function toggleCollapse(e) {
      e.preventDefault();
      this.setState({
        collapsed: !this.state.collapsed
      });
    }
  }, {
    key: "render",
    value: function render() {
      var toggleButton = _react.default.createElement("a", {
        href: "#",
        className: "toggle-text-length-button",
        onClick: this.toggleCollapse
      }, this.state.collapsed ? this.props.expandButtonText : this.props.collapseButtonText);

      return _react.default.createElement("div", null, _react.default.createElement("p", {
        className: "text-area"
      }, this.state.collapsed ? this.state.shortText : this.props.text), this.state.showToggleButton ? toggleButton : null);
    }
  }]);

  return CollapsableText;
}(_react.default.Component);

CollapsableText.propTypes = {
  text: _propTypes.default.string.isRequired,
  shortTextMaxLength: _propTypes.default.number.isRequired,
  collapsed: _propTypes.default.bool,
  collapseButtonText: _propTypes.default.string.isRequired,
  expandButtonText: _propTypes.default.string.isRequired
};
var _default = CollapsableText;
exports.default = _default;
CollapsableText.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "toggleCollapse",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "e",
      "type": null
    }],
    "returns": null
  }],
  "displayName": "CollapsableText",
  "props": {
    "text": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": ""
    },
    "shortTextMaxLength": {
      "type": {
        "name": "number"
      },
      "required": true,
      "description": ""
    },
    "collapsed": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "collapseButtonText": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": ""
    },
    "expandButtonText": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": ""
    }
  }
};